import './App.css';
import { FaGithub, FaYoutube, FaTwitter, FaReact, FaHtml5, FaCss3, FaJs, FaNodeJs, FaGitAlt, FaFigma } from 'react-icons/fa';
import { FiMail, FiLink } from 'react-icons/fi';
import { SiTypescript, SiGraphql, SiVercel, SiNetlify, SiRailway, SiPostgresql, SiMysql, SiFirebase, SiMongodb, SiCplusplus, SiCsharp, SiExpress, SiElectron } from 'react-icons/si'
import blazapimg from './img/blazap.png'
import streamcircleimg from './img/streamcircle.png'
import thesetoolsimg from './img/thesetools.png'
import secretimg from './img/secret.png'
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Switch from "react-switch";

function App() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const [cursorVariant, setCursorVariant] = useState("default");
  const [color, setColor] = useState("#FFFFF");
  const [lang, setLang] = useState(null);
  const [cursor, setCursor] = useState(true);



  useEffect(() => {
    const mouseMove = e => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      })
    }

    window.addEventListener("mousemove", mouseMove);

    return () => {
      window.removeEventListener("mousemove", mouseMove);
    }
  }, []);

  const variants = {
    default: {
      backgroundColor: "#5656ff",
      opacity: 0.8,
      x: mousePosition.x - 16,
      y: mousePosition.y - 16,
    },
    text: {
      height: 80,
      width: 80,
      x: mousePosition.x - 40,
      y: mousePosition.y - 40,
      backgroundColor: color,
      opacity: 0.8
    }
  }

  const textEnter = (lang, color) => {
    setColor(color)
    setLang(lang)
    setCursorVariant("text");
  }
  const textLeave = () => {
    setLang(null)
    setCursorVariant("default");
  }


  const handleChange = (checked) => {
    setCursor(checked);
  }

  useEffect(() => {
    if (cursor) {
      document.body.classList.remove("offcursor");
    } else {
      document.body.classList.add("offcursor");
    }
  }, [cursor]);

  return (
    <section class="container">
      {cursor ? <motion.div
        className='cursor'
        variants={variants}
        animate={cursorVariant}
      >
        <a className='lang'>{lang}</a>
      </motion.div> : null}

      <div class="left-half">
        <article>
          <h2>Hey, i'm <a className='bold'>itroeix</a></h2>
          <div className='media'>
            <a className='github' onMouseEnter={() => textEnter("GitHub", "#000000")} onMouseLeave={textLeave} onClick={() => window.location = "https://github.com/itroeix"}><FaGithub /></a>
            <a className='twitter' onMouseEnter={() => textEnter("Twitter", "#0075FF")} onMouseLeave={textLeave} onClick={() => window.location = "https://twitter.com/itroeix"}><FaTwitter /></a>
            <a className='youtube' onMouseEnter={() => textEnter("YouTube", "#960000")} onMouseLeave={textLeave} onClick={() => window.location = "https://youtube.com/@itroeix"}><FaYoutube /></a><br />
            <a className='mailicon'><FiMail /></a>
            <a className='mymail'>itroeix@gmail.com</a>
          </div>
          <h2 className='bold'>about me</h2>
          <a>Hey, i’m itroeix from Spain, <br /> i’m a developer since 5 years ago.</a>
          <h2 className='bold'>skills</h2>
          <div className='skills'>
            <a className='skill' style={{ color: "#45DEFF" }} onMouseEnter={() => textEnter("React.js", "#008573")} onMouseLeave={textLeave}>
              <FaReact />
            </a>
            <a className='skill' style={{ color: "#45DEFF" }} onMouseEnter={() => textEnter("Electron", "#008573")} onMouseLeave={textLeave}><SiElectron /></a>

            <a className='skill' style={{ color: "#FF8C39" }} onMouseEnter={() => textEnter("HTML", "#FF8C39")} onMouseLeave={textLeave}><FaHtml5 /></a>
            <a className='skill' style={{ color: "#0075FF" }} onMouseEnter={() => textEnter("CSS", "#0075FF")} onMouseLeave={textLeave}><FaCss3 /></a>
            <a className='skill' style={{ color: "#FCFF64" }} onMouseEnter={() => textEnter("JS", "#8a9900")} onMouseLeave={textLeave}><FaJs /></a>
            <a className='skill' style={{ color: "#00A3FF" }} onMouseEnter={() => textEnter("TS", "#00A3FF")} onMouseLeave={textLeave}><SiTypescript /></a>
            <a className='skill' style={{ color: "#A1FF67" }} onMouseEnter={() => textEnter("Node.js", "#026300")} onMouseLeave={textLeave}><FaNodeJs /></a>
            <a className='skill' style={{ color: "#00A3FF" }} onMouseEnter={() => textEnter("Graphql", "#00A3FF")} onMouseLeave={textLeave}><SiGraphql /></a>
            <a className='skill' style={{ color: "#FFFFFF" }} onMouseEnter={() => textEnter("Express", "#000000")} onMouseLeave={textLeave}><SiExpress /></a>
            <a className='skill' style={{ color: "#FFFFFF" }} onMouseEnter={() => textEnter("Vercel", "#000000")} onMouseLeave={textLeave}><SiVercel /></a>
            <a className='skill' style={{ color: "#57FFAE" }} onMouseEnter={() => textEnter("Netlify", "#026300")} onMouseLeave={textLeave}><SiNetlify /></a>
            <a className='skill' style={{ color: "#A800F8" }} onMouseEnter={() => textEnter("Railway", "#A800F8")} onMouseLeave={textLeave}><SiRailway /></a>
            <a className='skill' style={{ color: "#4200FF" }} onMouseEnter={() => textEnter("Postgres", "#4200FF")} onMouseLeave={textLeave}><SiPostgresql /></a>
            <a className='skill' style={{ color: "#FFA06B" }} onMouseEnter={() => textEnter("MySQL", "#FFA06B")} onMouseLeave={textLeave}><SiMysql /></a>
            <a className='skill' style={{ color: "#FFF85B" }} onMouseEnter={() => textEnter("Firebase", "#8a9900")} onMouseLeave={textLeave}><SiFirebase /></a>
            <a className='skill' style={{ color: "#43CF02" }} onMouseEnter={() => textEnter("MongoDB", "#026300")} onMouseLeave={textLeave}><SiMongodb /></a>
            <a className='skill' style={{ color: "#4D49FF" }} onMouseEnter={() => textEnter("C++", "#4D49FF")} onMouseLeave={textLeave}><SiCplusplus /></a>
            <a className='skill' style={{ color: "#BA48FF" }} onMouseEnter={() => textEnter("C#", "#BA48FF")} onMouseLeave={textLeave}><SiCsharp /></a>
            <a className='skill' style={{ color: "#FF661A" }} onMouseEnter={() => textEnter("Git", "#bb3e00")} onMouseLeave={textLeave}><FaGitAlt /></a>
            <a className='skill' style={{ color: "#fa46f5" }} onMouseEnter={() => textEnter("Figma", "#fa46f5")} onMouseLeave={textLeave}><FaFigma /></a>

          </div>
          <div className='settings'>
            <a className='bold'>Cursor: </a><br />
            <Switch onChange={handleChange} checked={cursor} className='switch'
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#0040BC"
              cursor="none"
            />
          </div>


        </article>
      </div>
      <div class="right-half">
        <article>

          <div className='proyects'>
            <h2 className='bold'>Main Proyects</h2>
            <p className='subproyects'>more proyects in my github!</p>
            <div className='table'>
              <div className='blazap'>
                <img className='proyectimg' src={blazapimg} /><br />
                <a className='proyecttitle'>Blazap</a><br /><br />
              </div>
              <div className='streamcircle'>
                <img className='proyectimg' src={streamcircleimg} /><br />
                <a className='proyecttitle'>StreamCircle</a><br />
                <a>Redoing</a>
              </div>
            </div><br />
            <div className='table'>
              <div className='thesetools'>
                <img className='proyectimg' src={thesetoolsimg} /><br />
                <a className='proyecttitle'>TheseTools</a><br />
                <a className='link' onMouseEnter={() => textEnter("GitHub", "#000000")} onMouseLeave={textLeave} onClick={() => window.location = "https://github.com/itroeix/thesetools"}><FaGithub /></a>
              </div>
              <div className='oncircle'>
                <img className='proyectimg' src={secretimg} /><br />
                <a className='proyecttitle'>OnCircle</a><br />
                <a>Coming soon</a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

export default App;
